import * as types from './actionTypes';

export function addCaseToRecent(caseToAdd) {
  return {
    type: types.ADD_CASE,
    caseNumber: caseToAdd,
    dateUpdated: Date.now(),
  };
}

export function removeCaseFromRecent(caseToRemove) {
  return {
    type: types.REMOVE_CASE,
    caseNumber: caseToRemove,
  };
}

export function removeAllCasesFromRecent(casesToBeRemoved) {
  return {
    type: types.REMOVE_ALL_OPEN_CASES,
    caseNumbers: casesToBeRemoved,
  };
}
